<template lang="pug">
div
    .box
        v-client-table(
            :columns='columns',
            :data='transaction_breakdown',
            :options='dtOptions',
            ref='dtTransactionBreakdown',
            name='dt-transaction-breakdown'
        )
            template(slot='beforeTable')
                box-loader(:loading='onLoading("fetch-summary")')

    .box
        v-client-table(
            :columns='detailsColumns',
            :data='transaction_breakdown',
            :options='dtDetailsOptions',
            ref='dtTransactionBreakdownDetails',
            name='dt-transaction-breakdown-details'
        )
            template(slot='beforeTable')
                box-loader(:loading='onLoading("fetch-summary")')
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Unleash from '@js/plugins/unleash';

export default {
    data() {
        let actionButtons = [];
        let actionButtons2 = [];

        actionButtons.push({
            title: 'Export',
            action: [
                {
                    title: 'CSV',
                    callback: () => {
                        this.downloadExport('CSV', 1);
                    },
                },
                {
                    title: 'XLSX',
                    callback: () => {
                        this.downloadExport('XLSX', 1);
                    },
                },
                {
                    title: 'PDF',
                    callback: () => {
                        this.downloadExport('PDF', 1);
                    },
                },
            ],
        });

        actionButtons2.push({
            title: 'Export',
            action: [
                {
                    title: 'CSV',
                    callback: () => {
                        this.downloadExport('CSV', 2);
                    },
                },
                {
                    title: 'XLSX',
                    callback: () => {
                        this.downloadExport('XLSX', 2);
                    },
                },
                {
                    title: 'PDF',
                    callback: () => {
                        this.downloadExport('PDF', 2);
                    },
                },
            ],
        });

        return {
            transaction_breakdown: [],
            dtOptions: {
                useReportFilter: true,
                columnsDropdown: true,
                filterable: false,
                perPage: 2000,
                perPageValues: [2000],
                headings: {
                    receipt_date: 'Receipt Date',
                    total: 'Total',
                    total_cash: 'Cash',
                    total_credit_card: 'Cards',
                    total_setel: 'Setel',
                    total_voucher: 'E-Voucher',
                    total_others: 'Others',
                },
                actionButtons: actionButtons,
                texts: {
                    title: 'Transaction Breakdown By Payment Method',
                    description:
                        'Shows transaction breakdown by payment method',
                    detail: '',
                },
                columnsClasses: {
                    receipt_date: 'text-left',
                    total: 'text-right',
                    total_cash: 'text-right',
                    total_credit_card: 'text-right',
                    total_setel: 'text-right',
                    total_voucher: 'text-right',
                    total_others: 'text-right',
                },
            },
            dtDetailsOptions: {
                useReportFilter: true,
                columnsDropdown: true,
                filterable: false,
                perPage: 2000,
                perPageValues: [2000],
                headings: {
                    receipt_date: 'Receipt Date',
                    total: 'Total',
                    cash: 'Cash',
                    ipt: 'IPT',
                    edc: 'EDC',
                    opt: 'OPT',
                    on_account: 'On Account',
                    setel: 'Setel',
                    'e-voucher': 'E-Voucher',
                    voucher: 'Voucher',
                    cardless: 'Mesra Cardless',
                    qr_pay: 'Qr Pay',
                    'e-wallet': 'E-Wallet',
                },
                actionButtons: actionButtons2,
                texts: {
                    title: 'Transaction Breakdown Details By Payment Type',
                    description: 'Shows transaction breakdown by payment type',
                    detail: '',
                },
                columnsClasses: {
                    receipt_date: 'text-left',
                    total: 'text-right',
                    cash: 'text-right',
                    ipt: 'text-right',
                    edc: 'text-right',
                    opt: 'text-right',
                    on_account: 'text-right',
                    setel: 'text-right',
                    'e-voucher': 'text-right',
                    voucher: 'text-right',
                    cardless: 'text-right',
                    qr_pay: 'text-right',
                    'e-wallet': 'text-right',
                },
            },
        };
    },

    computed: {
        ...mapGetters(['dateFilter']),
        ...mapState('tillFilter', ['filters']),

        api() {
            return Laroute.route('franchise.report.transaction.es.breakdown');
        },

        outlet() {
            return this.$store.getters.activeOutlet;
        },

        columns() {
            return [
                'receipt_date',
                'total',
                'total_cash',
                'total_credit_card',
                'total_setel',
                'total_voucher',
                'total_others',
            ];
        },

        detailsColumns() {
            const isEnableQrMop2 = Unleash.hasFeature('qr_mop');

            return isEnableQrMop2
                ? [
                      'receipt_date',
                      'total',
                      'cash',
                      'ipt',
                      'edc',
                      'opt',
                      'on_account',
                      'setel',
                      'e-voucher',
                      'voucher',
                      'cardless',
                      'qr_pay',
                      'e-wallet',
                  ]
                : [
                      'receipt_date',
                      'total',
                      'cash',
                      'ipt',
                      'edc',
                      'opt',
                      'on_account',
                      'setel',
                      'e-voucher',
                      'voucher',
                      'cardless',
                      'e-wallet',
                  ];
        },
    },

    watch: {
        outlet() {
            this.fetchReport();
        },

        dateFilter(a, b) {
            if (a == b) return;
            this.fetchReport();
        },

        filters: function(to, from) {
            if (to === from) return;
            this.fetchReport();
        },

        query() {
            this.filters();
        },
    },

    mounted() {
        this.fetchReport();
    },

    methods: {
        async fetchReport() {
            this.startLoading('fetch-summary');

            let options = {
                since: this.$store.getters.startDate.format(),
                until: this.$store.getters.endDate.format(),
                outlet_id: this.outlet,
                query: this.query,
                filters: this.filters,
            };

            try {
                const { data } = await this.$http.get(this.api, {
                    params: options,
                });
                this.transaction_breakdown = this.formatData(data.data);
            } catch (e) {
                toastr.error(e.message);
            } finally {
                this.endLoading('fetch-summary');
            }
        },

        formatData(data) {
            data.forEach(d => {
                for (const [key, value] of Object.entries(d)) {
                    if (key === 'receipt_date') {
                        d[key] = moment(value)
                            .format('dddd, DD MMM YYYY')
                            .toUpperCase();
                    } else {
                        d[key] = this.numberFormat(value);
                    }
                }
            });

            return data;
        },

        numberFormat(total) {
            return numeral(total).format('0,0.00');
        },

        downloadExport(type, url) {
            let route;

            let options = {
                since: this.$store.getters.startDate.format(),
                until: this.$store.getters.endDate.format(),
                outlet_id: this.outlet,
                tags_id: this.tags,
                query: this.query,
                filters: this.filters,
            };

            if (url === 1) {
                route = Laroute.route(
                    'franchise.report.transaction.es.breakdown_export',
                    {
                        type,
                    },
                );
            }

            if (url === 2) {
                route = Laroute.route(
                    'franchise.report.transaction.es.breakdown_details_export',
                    { type },
                );
            }

            window.open(route + '?' + $.param(options), '_blank');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/transaction/es-report/transaction-breakdown-es.vue